import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-center justify-space-between" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Справочник норм потребления")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Продовольственная категория"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Шифр категории"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Средняя норма"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Количество талонов в месяц")
  ])
], -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "d-flex align-center justify-center" }
const _hoisted_5 = { class: "d-flex align-center justify-center" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, null, -1)
const _hoisted_8 = { class: "text-center font-weight-bold" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "text-center",
    style: {"border-top":"0"}
  }, "Нет данных")
], -1)
const _hoisted_11 = [
  _hoisted_10
]

import { Ref, computed, ref } from 'vue'
import {
  ConsumptionRates,
  ConsumptionRate,
  ConsumptionRatesService,
  MAX_COUPONS_COUNT_PER_MONTH,
  PRODUCT_CATEGORIES_INFO,
  ProductCategory,
  MAX_COUPONS_BY_CATEGORY,
  AppAuthService,
  Permissions,
  PRODUCT_CATEGORIES_HANDBOOKS_UNITS,
} from '@prodcard/core'
import { VFieldEditable } from '../../../../components'
import { createCtx, handleError } from '../../../../helpers'
import { useAuthPermissions } from '../../../../mixins'
import { toArray } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsumptionRatesListPage',
  props: {
    consumptionRatesService: {},
    authService: {}
  },
  setup(__props: any) {

const props = __props;

const integerRegexp = new RegExp(/(^[0-9]*$)|(^-[0-9]+$)/)



const { hasPermissions } = useAuthPermissions(props.authService)
const hasManage = computed(() => hasPermissions(Permissions.CONSUMPTION_RATES_MANAGE))

const loading = ref(false)
const consumptionRates: Ref<ConsumptionRates | undefined> = ref(undefined)

handleError(async () => {
  consumptionRates.value = await props.consumptionRatesService.get(createCtx())
}, loading)

const updateConsumptionRate = async (productCategory: ProductCategory, consumptionRate: Partial<ConsumptionRate>) => {
  handleError(async () => {
    await props.consumptionRatesService.updateByProductCategory(createCtx(), productCategory, consumptionRate)

    const response = await props.consumptionRatesService.get(createCtx())
    if (consumptionRates.value) consumptionRates.value[productCategory] = response[productCategory]
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_card, {
        loading: loading.value,
        disabled: loading.value,
        class: "mt-8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_table, { hover: "" }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consumptionRates.value, (consumptionRate, productCategory) => {
                  return (_openBlock(), _createElementBlock("tr", { key: productCategory }, [
                    _createElementVNode("td", null, _toDisplayString(`${_unref(PRODUCT_CATEGORIES_INFO)[productCategory]?.description} ${
                  _unref(PRODUCT_CATEGORIES_HANDBOOKS_UNITS)[productCategory] || ''
                }`), 1),
                    _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(PRODUCT_CATEGORIES_INFO)[productCategory]?.shorthand), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", null, _toDisplayString(consumptionRate.averageRate), 1),
                        (hasManage.value)
                          ? (_openBlock(), _createBlock(_unref(VFieldEditable), {
                              "model-value": consumptionRate.averageRate,
                              key: consumptionRate.averageRate,
                              rules: [
                    v => v >= 0 || 'Средняя норма не может быть меньше 0',
                    v => _unref(integerRegexp).test(v) || 'Значение не может быть дробным',
                  ],
                              type: "number",
                              "clear-after-close": "",
                              onUpdate: ($event: any) => (updateConsumptionRate(productCategory, { averageRate: Number($event) }))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  class: "ml-2",
                                  variant: "text",
                                  color: "primary",
                                  size: "small",
                                  density: "comfortable",
                                  icon: "mdi-pencil"
                                }, props), null, 16)
                              ]),
                              _: 2
                            }, 1032, ["model-value", "rules", "onUpdate"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, _toDisplayString(consumptionRate.couponsCountPerMonth), 1),
                        (hasManage.value)
                          ? (_openBlock(), _createBlock(_unref(VFieldEditable), {
                              "model-value": consumptionRate.couponsCountPerMonth,
                              key: consumptionRate.couponsCountPerMonth,
                              rules: [
                    v =>
                      v <= _unref(MAX_COUPONS_BY_CATEGORY)[productCategory] ||
                      `Количество талонов не должно превышать ${_unref(MAX_COUPONS_BY_CATEGORY)[productCategory]}`,
                    v => v >= 0 || 'Количество талонов не может быть меньше 0',
                    v => _unref(integerRegexp).test(v) || 'Значение не может быть дробным',
                  ],
                              type: "number",
                              "clear-after-close": "",
                              onUpdate: ($event: any) => (updateConsumptionRate(productCategory, { couponsCountPerMonth: Number($event) }))
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  class: "ml-2",
                                  variant: "text",
                                  color: "primary",
                                  size: "small",
                                  density: "comfortable",
                                  icon: "mdi-pencil"
                                }, props), null, 16)
                              ]),
                              _: 2
                            }, 1032, ["model-value", "rules", "onUpdate"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              (consumptionRates.value)
                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_6, [
                    _createElementVNode("tr", null, [
                      _hoisted_7,
                      _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(toArray)(consumptionRates.value).reduce((acc, curr) => acc + curr.couponsCountPerMonth, 0)) + " из " + _toDisplayString(_unref(MAX_COUPONS_COUNT_PER_MONTH)), 1)
                    ])
                  ]))
                : (!loading.value)
                  ? (_openBlock(), _createElementBlock("tfoot", _hoisted_9, _hoisted_11))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})